import EmployeeTrainingDetail from './EmployeeTrainingDetail';

export default EmployeeTrainingDetail;
